import { ComponentRenderHooks } from "@/plugins/types";
import EditorColumns from "./Columns";
import settings from "./settings";
import Properties from "./Properties";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Columns") {
    return [EditorColumns];
  }
  if (hook.id === ComponentRenderHooks.PROPERTIES && hook.type === "Columns") {
    return Properties(payload);
  }
};
